import Icon from '../components/Icon.vue'

Icon.register({"openid":{"width":1792,"height":1792,"paths":[{"d":"M1086 0v1536l-272 128q-228-20-414-102t-293-208.5-107-272.5q0-140 100.5-263.5t275-205.5 391.5-108v172q-217 38-356.5 150t-139.5 255q0 152 154.5 267t388.5 145v-1360zM1755 582l37 390-525-114 147-83q-119-70-280-99v-172q277 33 481 157z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/openid.js
// module id = 499
// module chunks = 0